import AggregableColumnManager from '../aggregable/AggregableColumnManager';

export default class ForecastingColumnManager extends AggregableColumnManager {
}